var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewsletterBrMob(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 446,
    height: 381,
    viewBox: "0 0 446 381",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M428.592 353.028C291.594 390.021 154.259 390.021 17.2976 353.028C10.1992 350.999 2.98879 324.621 1.90535 294.652C-0.635117 224.725 -0.635117 156.047 1.90535 86.1207C2.98879 56.1521 10.1992 29.7735 17.2976 27.7444C154.296 -9.24812 291.631 -9.24812 428.592 27.7444C435.69 29.7735 442.901 56.1521 443.984 86.1207C446.487 156.047 446.487 224.725 443.984 294.652C442.901 324.621 435.69 350.999 428.592 353.028Z",
    fill: "#90C040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsletterBrMob);
export default __webpack_public_path__ + "static/media/newsletter-br-mob.d3ea0c428ad43a2c9df6ac3ea266a520.svg";
export { ForwardRef as ReactComponent };